exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/** \n* Пагинация =====================================================\n*/\n/**\n* Хлебные крошки\n*/\n.description .description__line[data-v-170c9a0c] {\n  line-height: 1.5;\n  letter-spacing: 0.2px;\n  text-align: center;\n  width: 55%;\n  margin: auto;\n}\n@media screen and (max-width: 575.98px) {\n.description .description__line[data-v-170c9a0c] {\n    width: 100%;\n    font-size: 14px;\n    text-align: left;\n    line-height: 1.57;\n}\n}\n[data-v-170c9a0c] .block-about__link {\n  color: #00afa1;\n}\n[data-v-170c9a0c] .block-about__link:hover {\n  opacity: 0.8;\n}", ""]);

// exports
